import { AnalyticsHTMLAttributes, AnalyticsTrackedElements, } from './analytics.enums.js';
export class DigitalSharedAnalytics {
    /**
     * Sets the property on the new event based on the old event's property
     * @param newEvent
     * @param originalEvent
     * @param prop
     * @param propValue
     */
    static { this.setPropertyOnEvent = (newEvent, originalEvent, prop, propValue) => {
        try {
            Object.defineProperty(newEvent, prop, {
                value: propValue || originalEvent[`${prop}`],
                writable: false,
            });
        }
        catch (err) { }
    }; }
    /**
     * function that provides a list of events given a list of the kinds of events
     * @returns list of event names
     */
    static { this.getAnalyticsEvents = () => {
        // create list of text within event names
        const eventOptionSubs = ['gesture', 'click', 'touch', 'change'];
        // if the event name contains any of the text in the array, it will be accounted for
        return Object.keys(window).filter((eventName) => {
            return (/^on/.test(eventName) &&
                new RegExp(eventOptionSubs.join('|')).test(eventName));
        });
    }; }
    /**
     * Sets listeners on an element and emits a cloned event to the light dom
     * @param element
     * @param componentVersionPropName
     * @param componentVersion
     */
    static { this.setHostEventHandlerForAnalytics = (element, componentVersionPropName = undefined, componentVersion = undefined) => {
        const events = DigitalSharedAnalytics.getAnalyticsEvents();
        for (const key of events) {
            const eventName = key.slice(2);
            const eventKey = `__event__${eventName}__handler`;
            element[eventKey] = (originalEvent) => {
                DigitalSharedAnalytics.dispatchNewEvent(element, eventName, componentVersionPropName, componentVersion, originalEvent);
            };
            // Adds event listener to the shadow root for each of the given events
            element.shadowRoot?.addEventListener(eventName, element[`__event__${eventName}__handler`], true);
        }
    }; }
    /**
     * UnSets listeners on an element and emits a cloned event to the light dom
     * @param element
     * @param componentVersionPropName
     * @param componentVersion
     */
    static { this.unsetHostEventHandlerForAnalytics = (element) => {
        const events = DigitalSharedAnalytics.getAnalyticsEvents();
        for (const key of events) {
            const eventName = key.slice(2);
            // Remove event listener to the shadow root for each of the given events
            element.shadowRoot?.removeEventListener(eventName, element[`__event__${eventName}__handler`], true);
        }
    }; }
    static dispatchNewEvent(element, eventName, componentVersionPropName = undefined, componentVersion = undefined, originalEvent) {
        // prevents cloning events from elements in the lightDOM(slotted content)
        if (!element.shadowRoot?.contains(originalEvent.target)) {
            return;
        }
        // Clones the original event
        const newEvent = new originalEvent.constructor(eventName, originalEvent);
        if (componentVersionPropName && componentVersion) {
            DigitalSharedAnalytics.setPropertyOnEvent(newEvent, null, componentVersionPropName, componentVersion);
        }
        for (const prop in originalEvent) {
            DigitalSharedAnalytics.setPropertyOnEvent(newEvent, originalEvent, prop);
        }
        element.dispatchEvent(newEvent);
    }
}
/**
 * Used to determine if the target element is already tracked by Omnibug Analytics
 * @param el an event target element
 * @returns a boolean indicating if the element is an AnalyticssTrackedElement: `<a>`, `<button>`, `<input type="submit">`,
 * and `<input type="button">`
 */
export function isAnalyticsTrackedElement(el) {
    const ANALYTICS_SELECTORS = Object.values(AnalyticsTrackedElements);
    return ANALYTICS_SELECTORS.some((selector) => el.matches(selector));
}
/**
 * Adds analytics attributes to slotted icon elements.
 *
 * The slotted icon is component-dependent and calling of this method can vary.
 */
export function addIconAnalyticsAttributes(icon, metricsText) {
    if (!icon || !metricsText) {
        return;
    }
    if (icon instanceof SVGElement) {
        icon.setAttribute(AnalyticsHTMLAttributes.CLICKABLE, 'true');
        icon.setAttribute(AnalyticsHTMLAttributes.TYPE, 'BTN');
        icon.setAttribute(AnalyticsHTMLAttributes.TEXT, metricsText);
    }
}
//# sourceMappingURL=analytics.js.map